<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import FiltroStatusItem from './FiltroStatusItem'

  export default {
    name: 'filtro-status-lotes',
    props: {
      value: {
        required: true
      },
      options: {
        type: Array,
        validator (opts) {
          return opts.every(opt => 'value' in opt && 'label' in opt)
        }
      }
    },
    data () {
      return {
        open: false
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      __onChange () {
        this.$nextTick(() => {
          this.$emit('change', this.model)
        })
      },
      __onFocus () {
        this.$emit('focus')
      },
      __onBlur () {
        this.$emit('blur')
      },
      bindClass (c) {
        return c
      }
    },
    components: {FiltroStatusItem},
    directives: {ClickOut}
  }
</script>

<template>
  <div>
    Filtrar pelo status
    <div class="btn-group dropdown" :class="{ open: open}" v-click-out="hide">
      <button class="btn btn-default no-bg no-border btn-xs" data-toggle="dropdown" aria-expanded="false"
              @click="toggle">
        Selecione <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <!--<li v-for="option in options">
          <a>
            {{ option.label }}
            <i class="fa fa-check pos-abs pos-r-sm tex-small m-t-xs sort-by-check inline"></i></a>
        </li>-->
        <filtro-status-item
          v-for="(opt, index) in options"
          :key="index"
          v-model="model"
          :val="opt.value"
          :label="opt.label"
          @focus="__onFocus"
          @blur="__onBlur"
          @change="__onChange"
          :class="bindClass(opt.class)">
        </filtro-status-item>
      </ul>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FiltroStatusLotes.vue?4c59277e